import { HiOutlineLightBulb } from "react-icons/hi2";

const PrimitiveHint: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => (
  <div className="flex space-x-1 items-center font-light text-sm max-w-2xl">
    <HiOutlineLightBulb className="shrink-0" />
    <div>{children}</div>
  </div>
);

export default PrimitiveHint;
